import { useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import isAuthenticated from "../isAuthenticated";
import { useAppSelector } from "../../../Hooks";

const PrivateRoute = () => {
  const user = useAppSelector(state => state.auth.user);
  let location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("location", location.pathname + location.search)
  }, )

  return <>{isAuthenticated(user) ? <Outlet /> : <Navigate to={"/login"} />}</>;
}

export default PrivateRoute;
